export default [
    {
        path: '/procurement/procurement-return',
        name: 'procurement-return',
        props: true,
        component: () => import('@/views/procurement/return/index.vue'),
        meta: {
            pageTitle: 'Return',
            breadcrumb: [
                {
                text: 'Return',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/procurement-return/add',
        name: 'create-procurement-return',
        component: () => import('@/views/procurement/return/create.vue'),
        meta: {
            pageTitle: 'Create Return',
            breadcrumb: [
                {
                text: 'Return',
                to: { name: 'procurement-return' },
                },
                {
                text: 'Create Return',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/procurement-return/:id',
        name: 'detail-procurement-return',
        props: true,
        component: () => import('@/views/procurement/return/detail.vue'),
        meta: {
            pageTitle: 'Detail Return',
            breadcrumb: [
                {
                text: 'Return',
                to: { name: 'procurement-return' },
                },
                {
                text: 'Detail Return',
                active: true,
                },
            ],
        },
    },
]